import {DateField, Panes, Select, TextField} from '@management-ui/core';
import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import CurrencySelect from '../../../../components/CurrencySelect';
import {ServiceContext} from '../../../../components/Services';
import {saveDate} from '../../../../utilities';

const Core = ({order = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [customers, setCustomers] = useState([]);
  const optionsLoaded = useRef(false);

  useEffect(() => {
    if (!optionsLoaded.current) {
      optionsLoaded.current = true;
      services.contact.getContacts({customers: '1'}, 1, 500).then((list) => {
        setCustomers(list.data.map(({id, name}) => ({title: name, value: id})));
      }).catch(() => null);
    }
  }, [services]);

  const handleReset = useCallback((subject) => {
    if (subject.customer) {
      subject.customer_id = `${subject.customer.id}`;
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={order}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Core Order Details',
          fields: [
            <Select
              name="customer_id"
              prefix={prefix}
              label="Customer"
              options={customers}
              rules={{required: 'Please select a customer'}}
            />,
            <DateField
              name="date"
              prefix={prefix}
              label="Date"
              rules={{required: 'Please select a date for this order'}}
            />,
            <TextField
              name="number"
              prefix={prefix}
              label="Sales Order Number (if left blank this will be auto-generated)"
            />,
            <CurrencySelect
              prefix={prefix}
            />,
          ]
        },
        {
          title: 'Consignment Details',
          fields: [
            <TextField
              name="number_of_loads"
              prefix={prefix}
              label="No. of Loads"
            />,

          ]
        }
      ]}
      title=""/>
  );
};

Core.onSave = ({customer_id, date, number, currency, number_of_loads}) => ({
  customer_id,
  date: saveDate(date),
  number,
  currency: currency ?? 'GBP',
  number_of_loads
});

export default Core;
